"use client";

import React, { useState } from "react";
import { UserProvider } from "@/context/ContextProvider"; // Ensure both are exported from the context file
import ScrollToTop from "./ScrollToTop";

import AppLayout from "./AppLayout";

export default function RootLayout({ children }) {
  const [isSidebarRightOpen, setIsSidebarRightOpen] = useState(false);
  const [isSidebarLeftOpen, setIsSidebarLeftOpen] = useState(false);

  return (
    <UserProvider>
      <html lang="en">
        <body
          className={`App ${
            isSidebarLeftOpen || isSidebarRightOpen ? "open" : ""
          }`}
        >
          <ScrollToTop />
          <AppLayout
            isSidebarLeftOpen={isSidebarLeftOpen}
            isSidebarRightOpen={isSidebarRightOpen}
            setIsSidebarLeftOpen={setIsSidebarLeftOpen}
            setIsSidebarRightOpen={setIsSidebarRightOpen}
          >
            {children}
          </AppLayout>
        </body>
      </html>
    </UserProvider>
  );
}
